import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
 
import VueI18n from 'vue-i18n'
import router from './router'
import VueScrollmagic from 'vue-scrollmagic'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faWheelchair, faLowVision, faDesktop, faAssistiveListeningSystems, faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons'
import {faLinkedin, faTwitter} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faWheelchair,faLowVision, faDesktop, faChalkboardTeacher,faAssistiveListeningSystems, faLinkedin, faTwitter )

Vue.component('font-awesome-icon', FontAwesomeIcon)

import './styles/style.scss'
import store from './store'
import i18n from './i18n'
import VeeValidate from "vee-validate"

import "./directives"

// Vue.use(VeeValidate, VueI18n, VueAxios, axios, VueScrollmagic)

Vue.use(VeeValidate)
Vue.use(VueI18n)
Vue.use(VueAxios, axios)
Vue.use(VueScrollmagic)

Vue.config.productionTip = false


new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
